export default __webpack_public_path__ + "static/media/jeremy-thumb.10649064.png";